module.exports = __webpack_public_path__ + "static/media/article102.79f248cb.jpg";